import { type FC } from "react";
import { generatePath } from "react-router-dom";

import { cx } from "@emotion/css";
import { AnalyticsIcon } from "@snapchat/snap-design-system-icons";

import { AbsoluteRoute } from "../../../../core/routes";
import { RouteEntities } from "../../../../core/routes/relativeRoutes";
import { useSelectedOrganizationContainer } from "../../../../shared/hooks";
import { LinkStyled, buttonDisabled } from "../../../../shared/styles";

const roundButtonClassnames =
    "ant-btn ant-btn-circle ant-btn-default sds-button regular sds-base-button default circle";

interface InsightsRoundButton {
    lensId: string;
    orgId?: string;
    lensFolderId?: string;
    insightsTab?: string;
    search?: string;
    isDisabled: boolean;
}

export const InsightsRoundButton: FC<InsightsRoundButton> = ({
    lensId,
    orgId: orgIdProp,
    lensFolderId: lensFolderIdProp,
    insightsTab = RouteEntities.Audience,
    search,
    isDisabled,
}) => {
    const { orgId: selectedOrgId, lensFolderId: selectedLensFolderId } = useSelectedOrganizationContainer();

    const orgId = orgIdProp ?? selectedOrgId;
    const lensFolderId = lensFolderIdProp ?? selectedLensFolderId;

    const urlParams = new URLSearchParams(search);
    urlParams.set("lensId", lensId);

    const insightsPath = lensFolderId
        ? generatePath(AbsoluteRoute.ORG_LENS_FOLDER_INSIGHTS_TAB, {
              orgId: orgId ?? "",
              lensFolderId,
              insightsTab,
          })
        : generatePath(AbsoluteRoute.ORG_INSIGHTS_TAB, { orgId: orgId ?? "", insightsTab });

    return (
        <LinkStyled
            to={`${insightsPath}?${urlParams.toString()}`}
            data-testid="lens-insights-btn"
            title="Lens Insights"
            className={cx(roundButtonClassnames, isDisabled && buttonDisabled)}
        >
            <AnalyticsIcon />
        </LinkStyled>
    );
};
